import { connect } from "react-redux";
import RatersResponseTable from "./RatersResponseTable";


const mapStateToProps = (state) => ({

    fetchTotalFeedbackProvidersApi: state.BenchmarkFilteringReducer.fetchTotalFeedbackProvidersApi

});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(RatersResponseTable);
